import React, { useEffect, useState } from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import styles from '../ChatWidget.module.scss';

const STOP_BUTTON_DELAY_MS = 500;

type StopButtonVariant = 'icon' | 'text';

export default function StopGenerationButton(props: { variant?: StopButtonVariant }) {
  const { isStreaming, stopGeneration } = useChatWidgetContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStreaming) {
      const timer = setTimeout(() => setVisible(true), STOP_BUTTON_DELAY_MS);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
      return undefined;
    }
  }, [isStreaming]);

  if (!visible) {
    return null;
  }

  if (props.variant === 'icon') {
    return (
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-full border-none bg-red-500 text-white cursor-pointer"
        style={{ width: '34px', height: '34px', fontSize: '14px', lineHeight: 1, padding: 0 }}
        onClick={stopGeneration}
        data-testid="chat-stop-button"
        title="Stop generating"
      >
        &#9632;
      </button>
    );
  }

  return (
    <button
      type="button"
      className={styles.stopButtonIcon}
      onClick={stopGeneration}
      data-testid="chat-stop-button"
      title="Stop generating"
    >
      &#9632;
    </button>
  );
}
